import React from "react";
import { useTranslation } from "react-i18next";
import { CartIcon } from "./CartIcon";
import { CartStep } from "./CartStep";

interface HeaderProps {
  title?: string
  count?: number
  step?: CartStep
}

export const Header = (props: HeaderProps) => {
  const { title, count, step } = props
  const { t } = useTranslation()

  return (
    <h1 className="text-center mb-4 text-3xl font-bold text-gray-800 position-relative">
      {step === CartStep.TestsAvailable ? t('shoppingCart.testsAvailable') :
      step === CartStep.ShoppingCart ? t('shoppingCart.shoppingCart') :
      step === CartStep.PanelDetails ? t('shoppingCart.panelDetails') :
      step === CartStep.Consent ? t('shoppingCart.patientAuthorization') :
      step === CartStep.PaymentAddress ? t('shoppingCart.billingAddress') :
      step === CartStep.Payment ? t('shoppingCart.payment') :
      step === CartStep.PaymentProblem ? <>&nbsp;</> :
      title}
      {step !== CartStep.PaymentSuccess && <div className="position-absolute bottom-0 end-0">
        <CartIcon count={count ?? 0} />
      </div>}
    </h1>
  )
}